<div class="modal">
    <i class="fal fa-times modal__close" (click)="close()"></i>
    <h2 class="mb-0075"> {{isCreate ? 'Create' : 'Update'}} Email</h2>
    <app-email-form [formControl]="emailControl">

    </app-email-form>

    <div class="col__ mt-0050" content-outlet="buttons">
        <button class="btn floatRight" type="button"
        data-test-id="saveEmailButton"
        [appButtonSpinner]="isSaving"
        [disabled]="emailControl.invalid || isSaving"
        (click)="onSaveClicked()"
        >Save</button>
    </div>

</div>
